import {Evaluator} from "@cm/graph-v3"
import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {ImageOpPerPixelFn} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/image-op-per-pixel-fn/node"
import {ImageOpContextImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-imgproc"
import {
    createImageOpImgProc,
    isImageOpImgProc,
} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/imgproc/image-op-imgproc-utils"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/levels/definition"
import {HalCompositorInfo} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/image-op-per-pixel-fn/hal"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {ImageOpParametersOfType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeLevels"}

@registerImageOpNode
export class ImageOpNodeLevels extends ImageOpPerPixelFn<typeof definition> {
    override get definition() {
        return nodeDefinition
    }

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(parameters)
    }

    protected getCompositingInfo(): HalCompositorInfo {
        return {
            compositingFunction: `
                vec3 bl = fetchSource(1).xyz;
                vec3 wl = fetchSource(2).xyz;
                vec3 gamma = fetchSource(3).xyz;
                vec3 offset = -bl;
                vec3 scale = vec3(1.0) / max(vec3(1e-3), wl - bl);
                vec4 source = fetchSource(0);
                vec4 result = vec4(pow(max(vec3(0.0), (source.rgb + offset) * scale), gamma), source.a);
                return result;
                `,
            sourceParameterNames: ["sourceImage", "blackLevel", "whiteLevel", "gamma"],
        }
    }

    override toImgProc = async (evaluator: Evaluator<ImageOpContextImgProc>, parameters: ImageOpParametersOfType<typeof definition, "imgproc">) => {
        const evaluatedParameters = await evaluator.getAll(parameters)
        return createImageOpImgProc(evaluatedParameters.sourceImage.descriptor, {
            type: "levels",
            input: evaluatedParameters.sourceImage.node,
            blackLevel: isImageOpImgProc(evaluatedParameters.blackLevel) ? evaluatedParameters.blackLevel.node : evaluatedParameters.blackLevel,
            whiteLevel: isImageOpImgProc(evaluatedParameters.whiteLevel) ? evaluatedParameters.whiteLevel.node : evaluatedParameters.whiteLevel,
            gamma: evaluatedParameters.gamma,
        })
    }
}
